import * as React from 'react';

function CircleButton(props) {
    const { type, value, onClick } = props;
    return (
        <div className={`circle-btn ${type}`} onClick={onClick}>
            {value}
        </div>
    );
}

export default CircleButton;
